import script from "./LiteSubtopics.vue?vue&type=script&setup=true&lang=js"
export * from "./LiteSubtopics.vue?vue&type=script&setup=true&lang=js"

import "./LiteSubtopics.vue?vue&type=style&index=0&id=312f7538&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-312f7538"]])

export default __exports__